<template>
  <Modal
    class="cc-modal"
    width="800"
    footer-hide
    v-model="visibility"
    title="我的模板列表"
  >
    <div class="content" v-if="data">
      <div class="bj-rows" style="margin-bottom: 20px">
        <Input
          class="bj-input-h45 bj-hover-input-F85A36"
          v-model="templateName"
          placeholder="请输入搜索的模板名称"
          style="width: 300px"
          clearable
        />
        <div style="margin-left: 20px">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="bj-search-btn-fff" @click="onSearchCancel"
            >重置</Button
          >
        </div>
      </div>
      <Table
        class="bj-fff-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="templateName" slot-scope="{ row, index }">
          <div style="display: flex">
            <Radio
              v-model="row.checked"
              @on-change="($evnet) => onRadioChange($evnet, row, index)"
            >
              {{ row.name }}</Radio
            >
          </div>
        </template>
        <template slot="name" slot-scope="{ row }">
          <div>
            {{ row.type === 0 ? row.locName : row.locBusinessName }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="table-btn" @click="showDetail(row)">查看模板</div>
        </template>
      </Table>
    </div>
    <div class="foot">
      <div class="page-tool" style="justify-content: flex-start">
        <Page
          class="pages-fff"
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          @on-change="onPageChange"
        />
      </div>
      <div>
        <Button
          @click="onConfirm"
          class="modal-confirm"
          style="margin-right: 20px"
          >确定</Button
        >
        <Button @click="onCancel" class="modal-cancel">取消</Button>
      </div>
    </div>
    <!-- 模板详情模态框 -->
    <templateInfoModal
      :show.sync="templateInfoModalVisibility"
      :data="templateInfoModalDetail"
    ></templateInfoModal>
  </Modal>
</template>
<script>
import { templatesList } from "api/domain.js";
import templateInfoModal from "components/template/templateInfoModal.vue";
export default {
  name: "templateListModal",
  components: {
    templateInfoModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          title: "模板名称",
          slot: "templateName",
          align: "center",
        },
        {
          title: "联系人",
          slot: "name",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      templateName: "",
      page: 1,
      limit: 10,
      total: 0,
      data: [],
      value: {}, // 选中的数据
      templateInfoModalVisibility: false, // 模板详情
      templateInfoModalDetail: {}, // 模板详情数据
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.req_getList();
        }
      },
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  mounted() {
    console.log("mounted");
  },
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  methods: {
    // 获取数据
    async req_getList() {
      try {
        let params = {
          name: this.templateName,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await templatesList(params);
        this.tableLoading = false;
        if (code === 200) {
          let array = data.list.map((o) => {
            let item = { ...o, checked: false };
            if (o.id === this.id) {
              item.checked = true;
            }
            return { ...item };
          });
          this.data = array;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 取消
    onCancel() {
      this.visibility = false;
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.templateName = "";
      this.onPageChange(1);
    },
    // 分页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 选中域名
    onRadioChange(event, val, index) {
      this.value = val;
      this.data.forEach((item, findex) => {
        if (findex !== index) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
    },
    // 确定
    onConfirm() {
      this.$emit("onChecked", this.value);
      this.onCancel();
    },
    // 查看详情
    showDetail(val) {
      this.templateInfoModalVisibility = true;
      this.templateInfoModalDetail = val;
    },
  },
};
</script>
<style lang="less" scoped>
.foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  margin-top: 0;
}
</style>
